
class Swiper {
    constructor(options) {
        this.default = {
            item: '.swiper-item',
            direction: 'horizontal',
            activeClass: 'active',
            threshold: 50,
            duration: 300,
            auto: false,
            loop: false,
            interval: 3000,
            height: 'auto',
            minMovingDistance: 0
        };
        this.options = Object.assign({}, this.default, options);
        this.options.height = this.options.height.replace('px', '');
        this.dragging = false;
        this.startX = this.startY = this.moveX = this.moveY = this.endX = this.endY = 0;
        this.eventHandlers = {};
        this.prev = this.current = this.goto = 0;
        this.width = this.height = this.distance = 0;
        this.offset = [];
        this.$container = this.options.container;
        if(!this.$container) {
            return;
        }
        this.$items = this.$container.querySelectorAll(this.options.item);
        this.count = this.$items.length;
        this.realCount = this.$items.length;
        this.position = [];
        if(!this.count) {
            return;
        }
        this.init();
        this.auto();
        this.bind();
        this.onResize();
        return this;
    }

    auto = () => {
        this.stop();
        if(this.options.auto) {
            this.timer = setTimeout(() => {
                this.next();
            }, this.options.interval);
        }
    }

    updateItemWidth = () => {
        this.width = this.$container.offsetWidth || document.documentElement;
        this.distance = this.options.direction === 'horizontal' ? this.width : this.height;
    }

    stop = () => {
        this.timer && clearTimeout(this.timer);
    }

    loop = () => {
        return this.options.loop && this.realCount >= 2;
    }

    onResize = () => {
        this.resizeHandler = () => {
            requestAnimationFrame(() => {
                this.updateItemWidth();
                this.setOffset();
                this.setTransition('none');
                this.setTransform();
            });
        };
        window.addEventListener('orientationchange', this.resizeHandler, false);
        window.addEventListener('resize', this.resizeHandler, false);
    }

    init = () => {
        this.height = this.options.height === 'auto' ? 'auto' : this.options.height - 0;
        this.updateItemWidth();
        this.initPosition();
        this.activate(this.current);
        this.setOffset();
        this.setTransform();
        if(this.loop()) {
            this.loopRender();
        }
    }

    initPosition = () => {
        for(let i = 0; i < this.realCount; i++) {
            this.position.push(i);
        }
    }

    movePosition = (position) => {
        if(position > 0) {
            let firstIndex = this.position.splice(0, 1);
            this.position.push(firstIndex[0]);
        } else if(position < 0) {
            let lastIndex = this.position.pop();
            this.position.unshift(lastIndex);
        }
    }

    setOffset = () => {
        let index = this.position.indexOf(this.current);
        this.offset = [];
        for(let i = 0, len = this.$items.length; i < len; i++) {
            this.offset.push((i - index) * this.distance);
        }
    }

    setTransition = (duration) => {
        duration = duration || this.options.duration || 'none';
        let transition = duration === 'none' ? 'none' : duration + 'ms';
        const $items = this.$items;
        for(let i = 0, len = $items.length; i < len; i++) {
            $items[i].style.webkitTransition = transition;
            $items[i].style.transition = transition;
        }
    }

    setTransform = (offset) => {
        offset = offset || 0;
        const options = this.options;
        const $items = this.$items;
        for(let i = 0, len = $items.length; i < len; i++) {
            let distance = this.offset[i] + offset;
            let transform = `translate3d(${distance}px, 0, 0)`;
            if(options.direction === 'vertical') {
                transform = `translate3d(0, ${distance}px, 0)`
            }
            $items[i].style.webkitTransform = transform;
            $items[i].style.transform = transform;
        }
    }

    bind = () => {
        this.touchstartHandler = (e) => {
            this.dragging = true;
            this.stop();
            const event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
            this.startX = event.pageX;
            this.startY = event.pageY;
        };

        this.touchmoveHandler = (e) => {
            if(this.count === 1 || this.dragging === false) {
                return;
            }
            const event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
            this.moveX = event.pageX;
            this.moveY = event.pageY;
            let distanceX = this.moveX - this.startX;
            let distanceY = this.moveY - this.startY;
            let distance = distanceY;
            let noScrollerY = Math.abs(distanceX) > Math.abs(distanceY);
            if(this.options.direction === 'horizontal' && noScrollerY) {
                distance = distanceX;
            }
            if(!this.options.loop && (this.current === this.count - 1 || this.current === 0)) {
                distance = distance / 3;
            }
            if(((this.options.minMovingDistance && Math.abs(distance) >= this.options.minMovingDistance) || !this.options.minMovingDistance) && noScrollerY) {
                this.setTransform(distance);
            }
            noScrollerY && e.preventDefault();
        };

        this.touchendHandler = (e) => {
            if(this.count === 1 || this.dragging === false) {
                return;
            }
            this.dragging = false;
            const event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
            this.endX = event.pageX;
            this.endY = event.pageY;
            let distance = this.endY - this.startY;
            if(this.options.direction === 'horizontal') {
                distance = this.endX - this.startX;
            }
            distance = this.getDistance(distance);
            if(distance !== 0 && this.options.minMovingDistance && Math.abs(distance) < this.options.minMovingDistance) {
                return;
            }
            if(distance > this.options.threshold) {
                this.move(-1);
            } else if(distance < -this.options.threshold) {
                this.move(1);
            } else {
                this.move(0);
            }
            this.loopRender();
        };

        this.transitionEndHandler = (e) => {
            this.activate(this.current);
            let cb = this.eventHandlers.swiped;
            cb && cb.apply(this, [this.prev % this.count, this.current % this.count]);
            this.auto();
            this.loopRender();
            e.preventDefault();
        };

        // mobile
        this.$container.addEventListener('touchstart',this.touchstartHandler, false);
        this.$container.addEventListener('touchmove', this.touchmoveHandler, false);
        this.$container.addEventListener('touchend', this.touchendHandler, false);

        // pc
        this.$container.addEventListener('mousedown', this.touchstartHandler, false);
        this.$container.addEventListener('mousemove', this.touchmoveHandler, false);
        this.$container.addEventListener('mouseup', this.touchendHandler, false);

        this.$items[1] && this.$items[1].addEventListener('webkitTransitionEnd', this.transitionEndHandler, false);
        this.$items[1] && this.$items[1].addEventListener('transitionEnd', this.transitionEndHandler, false);
    }

    loopRender = () => {
        if(this.loop()) {
            if(this.offset[this.offset.length - 1] === 0) {
                this.$container.appendChild(this.$items[0]);
                this.loopEvent(1);
            } else if(this.offset[0] === 0) {
                this.$container.insertBefore(this.$items[this.$items.length - 1], this.$container.firstChild);
                this.loopEvent(-1);
            }
        }
    }

    loopEvent = (num) => {
        this.itemDestroy();
        this.$items = this.$container.querySelectorAll(this.options.item);
        this.$items[1] && this.$items[1].addEventListener('webkitTransitionEnd', this.transitionEndHandler, false);
        this.$items[1] && this.$items[1].addEventListener('transitionEnd', this.transitionEndHandler, false);
        this.movePosition(num);
        this.setOffset();
        this.setTransform();
    }

    getDistance = (distance) => {
        if(this.loop()) {
            return distance;
        } else {
            if(distance > 0 && this.current === 0) {
                return 0;
            } else if(distance < 0 && this.current === this.realCount - 1) {
                return 0;
            } else {
                return distance;
            }
        }
    }

    moveIndex = (num) => {
        if(num !== 0) {
            this.prev = this.current;
            this.current += this.realCount;
            this.current += num;
            this.current %= this.realCount;
        }
    }

    activate = (index) => {
        let clazz = this.options.activeClass;
        let $items = this.$items;
        for(let i = 0, len = $items.length; i < len; i++) {
            $items[i].classList.remove(clazz);
            if(index === Number($items[i].dataset.index)) {
                $items[i].classList.add(clazz);
            }
        }
    }

    go = (index) => {
        this.stop();
        index = index || 0;
        index += this.realCount;
        index = index % this.realCount;
        index = this.position.indexOf(index) - this.position.indexOf(this.current);
        this.moveIndex(index);
        this.setOffset();
        this.setTransition();
        this.setTransform();
        this.auto();
        return this;
    }

    next = () => {
        this.move(1);
        return this;
    }

    move = (num) => {
        this.go(this.current + num);
        return;
    }

    on = (event, callback) => {
        if(this.eventHandlers[event]) {
           console.error(`[swiper] event ${event} is already register`);
        }
        if(typeof callback !== 'function') {
            console.log('[swiper] parameter callback must be a function');
        }
        this.eventHandlers[event] = callback;
        return this;
    }

    itemDestroy = () => {
        const $items = this.$items;
        if($items.length) {
            for(let i = 0, len = $items.length; i < len; i++) {
                $items[i].removeEventListener('webkitTransitionEnd', this.transitionEndHandler, false);
                $items[i].removeEventListener('transitionEnd', this.transitionEndHandler, false)
            }
        }
    }

    destroy = () => {
        this.stop();
        this.current = 0;
        this.setTransform(0);
        const $container = this.$container;
        window.removeEventListener('orientationchange', this.resizeHandler, false);
        window.removeEventListener('resize', this.resizeHandler, false);
        $container.removeEventListener('touchstart', this.touchstartHandle, false);
        $container.removeEventListener('touchmove', this.touchmoveHandler, false);
        $container.removeEventListener('touchend', this.touchendHandler, false);
        $container.removeEventListener('mousedown', this.touchstartHandler, false);
        $container.removeEventListener('mousemove', this.touchmoveHandler, false);
        $container.removeEventListener('mouseup', this.touchendHandler, false);
        this.itemDestroy();
        if(this.options.loop && this.count === 2) {
            const $cloneItems = $container.querySelectorAll(`${this.options.item}-clone`);
            for(let i = 0; i < $cloneItems.length; i++) {
                $container.removeChild$(cloneItems[i]);
            }
        }
    }
}

export default Swiper;



// WEBPACK FOOTER //
// ./src/common/component/swiper/swiper.js